<div class="row mb-3">
    <label class="col-2 col-form-label" translate="CONFIRMATION_TRAINING_EVENT_COMPLETED_LABEL"></label>
    <div class="col-8">
        <pace-core-radio-input [(model)]="model.trainingEventCompletedOptions" [parentForm]="parentForm">
        </pace-core-radio-input>
    </div>
</div>
